import {
  Modal,
  ModalActions,
  ModalContent,
  Prose,
  Pushbutton
} from '@stratumn/atomic';

import to from 'await-to-js';
import graphql from 'babel-plugin-relay/macro';
import { removeTeamMember } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import { createFragmentContainer } from 'react-relay';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

export const RemoveTeamMemberModal = props => {
  const [submitted, setSubmit] = useState(false);

  const { environment, member, toggleModal } = props;
  const {
    teams: {
      nodes: [team]
    }
  } = member;

  const removeMemberGp = () => {
    withSpanAsync('removeTeamMember', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(
        removeTeamMember(
          environment,
          member.id,
          member.rowId,
          team.id,
          team.rowId,
          team.organization.rowId
        )
      );

      if (err) {
        setSubmit(false);
      } else {
        toggleModal();
      }

      return {};
    });
  };

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={toggleModal}
      title="Remove from Team"
    >
      <ModalContent>
        <Prose
          light
          text={`This action will remove **${member.name}** from the **${
            team.name
          }**`}
        />
      </ModalContent>
      <ModalActions>
        <Pushbutton data-testid="cancel-button" onClick={toggleModal}>
          cancel
        </Pushbutton>
        <Pushbutton
          data-testid="remove-button"
          disabled={submitted}
          onClick={removeMemberGp}
          warning
        >
          Remove from team
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

RemoveTeamMemberModal.propTypes = {
  environment: PropType.object.isRequired,
  member: PropType.object.isRequired,
  toggleModal: PropType.func.isRequired
};

export default createFragmentContainer(withGqlClient(RemoveTeamMemberModal), {
  member: graphql`
    fragment removeTeamMemberModal_member on User
    @argumentDefinitions(teamFilter: { type: "TeamFilter", defaultValue: {} }) {
      name
      id
      rowId
      teams(filter: $teamFilter) {
        nodes {
          id
          rowId
          name
          organization {
            rowId
          }
        }
      }
    }
  `
});
